import { createAction } from '@reduxjs/toolkit';
import { CALC_ENGINE_ACTION_PREFIX } from '../utilities/constants';

export const clearAllProjectData = createAction(
  `${CALC_ENGINE_ACTION_PREFIX}/clearAllProjectData`
);
